import GameCore from "../GameCore";
import BaseBullet from "./BaseBullet";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";

const BLAST_DURATION = 600;

export default class BlastBullet extends BaseBullet {
  previousArea: number;
  tween: Phaser.Tweens.Tween;
  tween2: Phaser.Tweens.Tween;
  constructor(
    group: BulletGroup,
    weapon: BaseWeapon,
    indexInWeapon = 0,
    x: number = 0,
    y: number = 0
  ) {
    super(group, weapon, indexInWeapon, "blast_0", x, y, "weapon_effects");
    this.previousArea = 0;
  }

  Init(x = -1000, y = -1000) {
    super.Init(x, y);
    this.setScale(0);
    this.previousArea = this.weapon.PArea;
    this.play("blast_attack");
    this.tween = this.scene.tweens.add({
      targets: this,
      scale: GameCore.PixelScale * this.weapon.PArea * 5,
      duration: BLAST_DURATION,
      ease: "Linear",
    });
    if (this.body) {
      const radius = this.width * 0.25;
      this.body.setCircle(radius);
      this.body.setOffset(radius, radius);
    }
  }

  OnRecycle() {
    super.OnRecycle();
    this.alpha = 1;

    // Reset and play animation
    this.play("blast_attack");

    if (this.tween) {
      if (this.previousArea !== this.weapon.PArea) {
        this.tween.stop();
        this.scene.tweens.remove(this.tween);
        this.setScale(0);
        this.tween = this.scene.tweens.add({
          targets: this,
          scale: GameCore.PixelScale * this.weapon.PArea * 5,
          duration: 600,
          ease: "Linear",
        });
      }
      if (this.tween.isActive()) {
        this.tween.restart();
      }
    }
    if (this.tween2 && this.tween2.isActive()) {
      this.tween2.restart();
    } else {
      this.tween2 = this.scene.tweens.add({
        targets: this,
        alpha: 0,
        duration: BLAST_DURATION,
        ease: "Linear",
        delay: 100,
        onComplete: () => {
          this.DeSpawn();
        },
      });
    }
    this.y -= 16 * this.indexInWeapon;
  }

  DeSpawn() {
    this.stop(); // Stop the animation
    super.DeSpawn();
  }
}
